export default __webpack_public_path__ + "static/media/london.e59bc581.png";